import { useOnlineStatus } from '@/lib/useOnlineStatus'
import { WifiOff } from 'lucide-react'

/**
 * States connectivity plainly, and — importantly — states the consequence.
 *
 * Because scans are submitted synchronously and not queued (a deliberate
 * decision: a scan that silently arrives an hour later is worse here than one
 * that visibly fails), the user needs to know *before* scanning that
 * submission will not go through.
 */
export function OfflineBanner() {
  const online = useOnlineStatus()
  if (online) return null

  return (
    <div
      role="status"
      className="pt-safe sticky top-0 z-40 bg-warn-500 text-[#3b2600]"
    >
      <div className="flex items-center justify-center gap-2 px-4 py-2">
        <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
        <p className="text-sm font-semibold">No connection — scans won't send</p>
      </div>
    </div>
  )
}
